module.exports = __webpack_public_path__ + "static/media/fvs_valve1_23.7c662b39.jpg";